// Felddefinitionen der Passdaten-Konfiguration

export const FELDTYP = {
  CHECKBOX: 'checkbox',
  MULTISELECT: 'multiselect',
  SELECT: 'select',
  SEGMENTED: 'segmented',
  TEXT: 'text',
};

export const PASSART_OPTIONS = [
  { value: 'OrdentlicherReisepass', text: 'Ordentlicher Reisepass' },
  { value: 'PersonalausweisDni', text: 'Personalausweis / DNI' },
];

export const DRINGLICHKEIT_OPTIONS = [
  { value: 0, text: 'Keine' },
  { value: 24, text: '24h' },
  { value: 48, text: '48h' },
];

export const EINREICHUNGSFRIST_OPTIONS = [
  { value: 'erstes', text: 'Erstes Releasedatum' },
  { value: 'letztes', text: 'Letztes Releasedatum' },
];

export const PASSDATEN_KEYS = [
  'passNummerRequired',
  'passNummerRequiredFlug',
  'passAusstellungsdatumRequired',
  'passAusstellungsdatumRequiredFlug',
  'passGueltigkeitsdatumRequired',
  'passGueltigkeitsdatumRequiredFlug',
  'passLandRequired',
  'passLandRequiredFlug',
  'passOrtRequired',
  'passOrtRequiredFlug',
];

export const KATEGORIEN = [
  {
    titel: 'Persönliche Daten',
    felder: [
      {
        label: 'Geburtsdatum',
        type: FELDTYP.CHECKBOX,
        keyDom: 'geburtsdatumRequired',
        keyFom: 'geburtsdatumRequiredFlug',
      },
      {
        label: 'Nationalität',
        type: FELDTYP.CHECKBOX,
        keyDom: 'nationalitaetRequired',
        keyFom: 'nationalitaetRequiredFlug',
      },
      {
        label: 'Geschlecht',
        type: FELDTYP.CHECKBOX,
        keyDom: 'geschlechtRequired',
        keyFom: 'geschlechtRequiredFlug',
      },
      {
        label: 'Geburtsort',
        type: FELDTYP.CHECKBOX,
        keyDom: 'geburtsortRequired',
        keyFom: 'geburtsortRequiredFlug',
      },
      {
        label: 'Geburtsland',
        type: FELDTYP.CHECKBOX,
        keyDom: 'geburtslandRequired',
        keyFom: 'geburtslandRequiredFlug',
      },
      { label: 'Berufsbezeichnung', type: FELDTYP.CHECKBOX, keyDom: 'berufsbezeichnungRequired' },
    ],
  },
  {
    titel: 'Passdaten',
    felder: [
      {
        label: 'Passnummer',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passNummerRequired',
        keyFom: 'passNummerRequiredFlug',
      },
      {
        label: 'Ausstelldatum',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passAusstellungsdatumRequired',
        keyFom: 'passAusstellungsdatumRequiredFlug',
      },
      {
        label: 'Gültigkeitsdatum',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passGueltigkeitsdatumRequired',
        keyFom: 'passGueltigkeitsdatumRequiredFlug',
      },
      {
        label: 'Ausstellungsland',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passLandRequired',
        keyFom: 'passLandRequiredFlug',
      },
      {
        label: 'Ausstellungsort',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passOrtRequired',
        keyFom: 'passOrtRequiredFlug',
      },
      {
        label: 'Passart',
        type: FELDTYP.MULTISELECT,
        keyDom: 'validePassarten',
        options: PASSART_OPTIONS,
        hinweis: 'Nur aktiv, wenn mindestens ein Passdaten-Feld gesetzt ist',
      },
    ],
  },
  {
    titel: 'Dokumente',
    felder: [
      {
        label: 'Passfarbkopie',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passkopieColorRequired',
        keyFom: 'passkopieColorRequiredFlug',
      },
      {
        label: 'Passfoto',
        type: FELDTYP.CHECKBOX,
        keyDom: 'passfotoRequired',
        keyFom: 'passfotoRequiredFlug',
      },
      { label: 'Versicherungsnachweis', type: FELDTYP.CHECKBOX, keyDom: 'versicherungsnachweisRequired' },
      { label: 'Verzichtserklärung', type: FELDTYP.CHECKBOX, keyDom: 'verzichtserklaerungRequired' },
      { label: 'LOI-Antrag', type: FELDTYP.CHECKBOX, keyDom: 'loiAntragRequired' },
      { label: 'Referenznr.-Antrag', type: FELDTYP.CHECKBOX, keyDom: 'referenznummerAntragRequired' },
      { label: 'Visakopie', type: FELDTYP.CHECKBOX, keyDom: 'visakopieRequired' },
      {
        label: 'Einverständnisformular',
        type: FELDTYP.CHECKBOX,
        keyDom: 'einverstaendnisformularRequired',
      },
    ],
  },
  {
    titel: 'Zusätzliche Infos',
    nurDom: true,
    hinweis: 'Nur für das DOM',
    felder: [
      {
        label: 'Dringlichkeit',
        type: FELDTYP.SELECT,
        keyDom: 'dringlichkeit',
        options: DRINGLICHKEIT_OPTIONS,
      },
      {
        label: 'Benachrichtigung an CM vor Release',
        type: FELDTYP.CHECKBOX,
        keyDom: 'benachrichtigungAnCmVorRelease',
      },
      {
        label: 'Einreichungsfrist',
        type: FELDTYP.SEGMENTED,
        keyDom: 'einreichungsfristZumErstenReleasedatum',
        options: EINREICHUNGSFRIST_OPTIONS,
      },
      { label: 'Grund', type: FELDTYP.TEXT, keyDom: 'grund' },
    ],
  },
];

export const ALLE_KEYS = KATEGORIEN.flatMap(kategorie =>
  kategorie.felder.flatMap(feld => (feld.keyFom ? [feld.keyDom, feld.keyFom] : [feld.keyDom]))
);
